<template>
  <div class="flex flex-col min-h-screen overflow-hidden supports-[overflow:clip]:overflow-clip">
    <!-- Site header -->
    <HeaderSection />

    <!-- Hero Section -->
    <section class="relative pt-16 md:pt-24 overflow-hidden pb-4">
      <ParticlesComponent class="absolute inset-0 -z-10" :quantity="10" :staticity="30" />
      <div class="absolute top-0 left-0 w-full h-40 bg-gradient-to-b from-cyan-500/10 to-transparent pointer-events-none -z-10"></div>
      <div class="max-w-3xl mx-auto px-4 text-center">
        <h1 class="text-4xl md:text-5xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-slate-50 to-cyan-200 mb-4 drop-shadow-lg">{{$t('privacy_hero_title')}}</h1>
        <p class="text-lg md:text-xl text-slate-300 mb-6 font-medium">{{$t('privacy_hero_subtitle')}}</p>
      </div>
    </section>

    <!-- Main Content -->
    <main class="grow flex justify-center bg-slate-900/90 py-8 px-2 mt-0 pt-0">
      <div class="w-full max-w-3xl space-y-8">
        <!-- Section 1 -->
        <section class="privacy-card">
          <div class="flex items-center mb-2">
            <svg class="w-7 h-7 text-cyan-400 mr-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M12 4v16m8-8H4"/></svg>
            <h2 class="privacy-section-title">{{$t('privacy_section1_title')}}</h2>
          </div>
          <p class="privacy-section-text"><strong>Protostars AI Software Ltd.</strong> {{$t('privacy_section1_text')}} <a href="https://www.protostars.ai" target="_blank" class="privacy-link">https://www.protostars.ai</a> {{$t('privacy_section1_text2')}}</p>
        </section>
        <!-- Section 2 -->
        <section class="privacy-card">
          <div class="flex items-center mb-2">
            <svg class="w-7 h-7 text-cyan-400 mr-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M8 12l2 2 4-4"/></svg>
            <h2 class="privacy-section-title">{{$t('privacy_section2_title')}}</h2>
          </div>
          <ul class="privacy-section-list">
            <li>{{$t('privacy_section2_list1')}}</li>
            <li>{{$t('privacy_section2_list2')}}</li>
            <li>{{$t('privacy_section2_list3')}}</li>
            <li>{{$t('privacy_section2_list4')}}</li>
            <li>{{$t('privacy_section2_list5')}}</li>
          </ul>
        </section>
        <!-- Section 3 -->
        <section class="privacy-card">
          <div class="flex items-center mb-2">
            <svg class="w-7 h-7 text-cyan-400 mr-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M8 10h8M8 14h6"/></svg>
            <h2 class="privacy-section-title">{{$t('privacy_section3_title')}}</h2>
          </div>
          <div class="privacy-section-text">
          <p class="">{{$t('privacy_section3_text1')}}</p>
          <p class="">{{$t('privacy_section3_text2')}}</p>
          <p class="">{{$t('privacy_section3_text3')}}</p>
          </div>
        </section>
        <!-- Section 4 -->
        <section class="privacy-card">
          <div class="flex items-center mb-2">
            <svg class="w-7 h-7 text-cyan-400 mr-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M12 20v-6m0 0V4m0 10l-3-3m3 3l3-3"/></svg>
            <h2 class="privacy-section-title">{{$t('privacy_section4_title')}}</h2>
          </div>
          <ul class="privacy-section-list">
            <li>{{$t('privacy_section4_list1')}}</li>
            <li>{{$t('privacy_section4_list2')}}</li>
            <li>{{$t('privacy_section4_list3')}}</li>
            <li>{{$t('privacy_section4_list4')}}</li>
            <li>{{$t('privacy_section4_list5')}}</li>
          </ul>
        </section>
        <!-- Section 5 -->
        <section class="privacy-card">
          <div class="flex items-center mb-2">
            <svg class="w-7 h-7 text-cyan-400 mr-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M17 16l4-4m0 0l-4-4m4 4H7"/></svg>
            <h2 class="privacy-section-title">{{$t('privacy_section5_title')}}</h2>
          </div>
          <p class="privacy-section-text">{{$t('privacy_section5_text')}}</p>
        </section>
        <!-- Section 6 -->
        <section class="privacy-card">
          <div class="flex items-center mb-2">
            <svg class="w-7 h-7 text-cyan-400 mr-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>
            <h2 class="privacy-section-title">{{$t('privacy_section6_title')}}</h2>
          </div>
          <p class="privacy-section-text">{{$t('privacy_section6_text')}}</p>
        </section>
        <!-- Section 7 -->
        <section class="privacy-card">
          <div class="flex items-center mb-2">
            <svg class="w-7 h-7 text-cyan-400 mr-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="7" rx="2"/><path d="M8 11V7a4 4 0 018 0v4"/></svg>
            <h2 class="privacy-section-title">{{$t('privacy_section7_title')}}</h2>
          </div>
          <p class="privacy-section-text">{{$t('privacy_section7_text')}}</p>
        </section>
        <!-- Section 8 -->
        <section class="privacy-card">
          <div class="flex items-center mb-2">
            <svg class="w-7 h-7 text-cyan-400 mr-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/></svg>
            <h2 class="privacy-section-title">{{$t('privacy_section8_title')}}</h2>
          </div>
          <p class="privacy-section-text">{{$t('privacy_section8_text')}}</p>
        </section>
        <!-- Section 9 -->
        <section class="privacy-card">
          <div class="flex items-center mb-2">
            <svg class="w-7 h-7 text-cyan-400 mr-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M9 9h6v6H9z"/></svg>
            <h2 class="privacy-section-title">{{$t('privacy_section9_title')}}</h2>
          </div>
          <p class="privacy-section-text">{{$t('privacy_section9_text')}}</p>
        </section>
        <!-- Section 10 -->
        <section class="privacy-card">
          <div class="flex items-center mb-2">
            <svg class="w-7 h-7 text-cyan-400 mr-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M12 20v-6m0 0V4m0 10l-3-3m3 3l3-3"/></svg>
            <h2 class="privacy-section-title">{{$t('privacy_section10_title')}}</h2>
          </div>
          <p class="privacy-section-text">{{$t('privacy_section10_text')}}</p>
        </section>
        <!-- Section 11 -->
        <section class="privacy-card">
          <div class="flex items-center mb-2">
            <svg class="w-7 h-7 text-cyan-400 mr-2" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M16 12a4 4 0 11-8 0 4 4 0 018 0z"/><path d="M12 16v2m0 4h.01"/></svg>
            <h2 class="privacy-section-title">{{$t('privacy_section11_title')}}</h2>
          </div>
          <address class="not-italic privacy-section-text">
            {{$t('privacy_section11_address')}}<br>
            {{$t('privacy_section11_email')}} <a href="mailto:contact@protostars.ai" class="privacy-link">contact@protostars.ai</a>
          </address>
        </section>
      </div>
    </main>

    <FooterSection />
  </div>
</template>

<script>
import HeaderSection from '@/partials/HeaderSection.vue'
import FooterSection from '@/partials/FooterSection.vue'
import ParticlesComponent from '@/partials/ParticlesComponent.vue'
export default {
  name: 'PrivacyPolicy',
  components: { HeaderSection, FooterSection, ParticlesComponent }
}
</script>

<style scoped>
.privacy-card {
  background: linear-gradient(120deg, rgba(51,65,85,0.98) 60%, rgba(85,214,247,0.04) 100%);
  border-radius: 1.25rem;
  box-shadow: 0 4px 32px 0 rgba(85, 214, 247, 0.08);
  padding: 2rem 1.5rem 1.5rem 1.5rem;
  margin-bottom: 0.5rem;
  border: 1px solid rgba(85,214,247,0.10);
  transition: box-shadow 0.2s;
}
.privacy-card:hover {
  box-shadow: 0 8px 40px 0 rgba(85, 214, 247, 0.18);
}
.privacy-section-title {
  font-size: 1.35rem;
  font-weight: 700;
  background: linear-gradient(90deg, #55DAF7 60%, #6366F1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.01em;
  margin-bottom: 0;
}
.privacy-section-text {
  color: #e0f2fe;
  font-size: 1.08rem;
  line-height: 1.7;
  margin-bottom: 0.5rem;
  padding: 1.25rem 1rem 0;
}
.privacy-section-list {
  border-radius: 1rem;
  padding: 1.25rem 1rem 0;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.privacy-section-list li {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding-left: 2rem;
  font-size: 1.08rem;
  color: #e0f2fe;
  font-weight: 500;
  line-height: 1.6;
}
.privacy-section-list li::before {
  content: '';
  flex-shrink: 0;
  position: absolute;
  left: 0.5rem;
  top: 0.3rem;
  transform: translateY(0);
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: linear-gradient(135deg, #55DAF7 60%, #6366F1 100%);
  box-shadow: 0 0 8px #55DAF788;
 /*border: 2px solid #334155;*/
}
.privacy-link {
  color: #55DAF7;
  text-decoration: underline;
  transition: color 0.2s;
}
.privacy-link:hover {
  color: #6366F1;
}
@media (max-width: 640px) {
  .privacy-card {
    padding: 1.25rem 0.5rem 1rem 0.5rem;
  }
  .privacy-section-title {
    font-size: 1.1rem;
  }
  .privacy-section-list {
    padding: 1rem 0.5rem;
  }
  .privacy-section-list li {
    font-size: 1rem;
    padding-left: 1.5rem;
  }
  .privacy-section-list li::before {
    width: 0.8rem;
    height: 0.8rem;
    left: 0.2rem;
    top: 0.15em;
  }
}
</style> 